import { fetchJsonWithAuth, apiGetWithAuth } from './authApi';
import { AUTH_URL, SUBMISSIONS_URL } from './apiConfig';

const TEST_FLOW_MODULE = 'test-flows';
const LMS_FLOW_MODULE = 'lms-flows';

const TEST_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

const LMS_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

export async function getDropdownFields(module) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;
  return apiGetWithAuth(SUBMISSIONS_URL, `/filter-dropdown-fields?module=${encodeURIComponent(module)}`);
}

export async function getFieldConfig(module) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;
  return apiGetWithAuth(AUTH_URL, `/admin/field-config?module=${encodeURIComponent(module)}`);
}

export async function getDropdownValues(module, field, search = '', limit = 50, offset = 0) {
  const params = new URLSearchParams({
    module, field, value: search,
    limit: String(limit), offset: String(offset),
  });
  return apiGetWithAuth(SUBMISSIONS_URL, `/filter-dropdown-values?${params}`);
}

export async function getModuleDataList(module, limit = 10, offset = 0, options = {}) {
  const { scope = '', sort = '', sortDir = '' } = options;

  if (module === TEST_FLOW_MODULE) {
    const { getTestFlows } = await import('./testingApi');
    const data = await getTestFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;
    return { items: rows, total, limit, offset, tabs: [{ key: 'all', title: 'Test Cases', count: total }] };
  }

  if (module === LMS_FLOW_MODULE) {
    const { getLmsFlows } = await import('./testingApi');
    const data = await getLmsFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;
    return { items: rows, total, limit, offset, tabs: [{ key: 'all', title: 'LMS Cases', count: total }] };
  }

  const params = new URLSearchParams({ module, limit: String(limit), offset: String(offset) });
  if (scope) params.set('scope', scope);
  if (sort) params.set('sort', sort);
  if (sortDir) params.set('sortDir', sortDir);

  return fetchJsonWithAuth(AUTH_URL, `/module-data-list?${params.toString()}`);
}
